const ROOT_SERVER_URL =
  window.location.protocol === 'http:' && window.location.port === '5000'
    ? `http://${window.location.hostname}:3001`
    : `${window.location.origin}`;

export function getConfig() {
  return fetch(`${ROOT_SERVER_URL}/open-api/config`).then((response) => response.json());
}
